/**
 * Main JavaScript
 * 
 * @package Fiscalfactu_Theme
 */

(function($) {
    'use strict';

    /**
     * Mobile menu toggle
     */
    function initMobileMenu() {
        const menuToggle = $('.menu-toggle');
        const primaryMenu = $('.primary-menu');

        menuToggle.on('click', function(e) {
            e.preventDefault();
            primaryMenu.toggleClass('is-active');
            $(this).attr('aria-expanded', primaryMenu.hasClass('is-active'));
        });
    }

    /**
     * Smooth scroll for anchor links
     */
    function initSmoothScroll() {
        $('a[href*="#"]:not([href="#"])').on('click', function(e) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && 
                location.hostname === this.hostname) {
                
                let target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                
                if (target.length) {
                    e.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 100
                    }, 800);
                }
            }
        });
    }

    /**
     * Initialize when DOM is ready
     */
    $(document).ready(function() {
        initMobileMenu();
        initSmoothScroll();
    });

})(jQuery);

